import { createContext, useContext } from "react";

/**
 * How a question is framed. "card" (default) = everything inside one card — what
 * inline hosts rely on (Mental+'s daily island question, the signup stratification
 * questions). "page" = the questionnaire screen: title and help on the page, the
 * choices as separate answer cards, other inputs in one answer card.
 */
export type QuestionLayout = "card" | "page";

/** Lets the answer components adapt to the page layout without a prop on each. */
export const QuestionLayoutContext = createContext<QuestionLayout>("card");

export const useQuestionLayout = (): QuestionLayout => useContext(QuestionLayoutContext);
